import { render, staticRenderFns } from "./TransitPermitRequest.vue?vue&type=template&id=2d27c134&scoped=true"
import script from "./TransitPermitRequest.vue?vue&type=script&lang=ts"
export * from "./TransitPermitRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d27c134",
  null
  
)

export default component.exports